import { Users, Building2, CheckCircle, Clock, Shield, LayoutGrid } from "lucide-react"
import { useGetStatsQuery } from "../features/admin/adminApi"

function StatCard({ icon: Icon, label, value, color }: { icon: any; label: string; value: number; color: string }) {
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-4 ${color}`}>
        <Icon size={20} className="text-white" />
      </div>
      <p className="text-2xl font-bold text-gray-900">{value.toLocaleString()}</p>
      <p className="text-sm text-gray-500 mt-1">{label}</p>
    </div>
  )
}

export default function OverviewPage() {
  const { data: stats, isLoading } = useGetStatsQuery()

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Overview</h1>

      {isLoading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 animate-pulse">
              <div className="w-10 h-10 bg-gray-200 rounded-lg mb-4" />
              <div className="h-6 bg-gray-200 rounded w-16 mb-2" />
              <div className="h-4 bg-gray-200 rounded w-24" />
            </div>
          ))}
        </div>
      ) : stats ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
          <StatCard icon={Users} label="Total Users" value={stats.totalUsers} color="bg-blue-500" />
          <StatCard icon={Building2} label="Total Businesses" value={stats.totalBusinesses} color="bg-purple-500" />
          <StatCard icon={CheckCircle} label="Verified Businesses" value={stats.verifiedBusinesses} color="bg-green-500" />
          <StatCard icon={Clock} label="Pending Reviews" value={stats.pendingReviews} color="bg-yellow-500" />
          <StatCard icon={Shield} label="Roles" value={stats.totalRoles ?? 0} color="bg-indigo-500" />
          <StatCard icon={LayoutGrid} label="Categories" value={stats.totalCategories ?? 0} color="bg-pink-500" />
        </div>
      ) : (
        <p className="text-gray-500">Failed to load stats.</p>
      )}
    </div>
  )
}
